import User from "@/models/User.js";

export default {
  namespaced: true,
  state: {
    errors: [],
    token: '',
    currentUser: {}
  },
  mutations: {
    setCurrentUser(state, user) {
      state.currentUser = user
    },    
    setToken(state, token) {
      state.token = token;
    },
    setErrors(state, error) {
      if(error == 'clear') {
        state.errors = []
      } else {
        state.errors.push(error)
      }
    }
  },
  actions: {
    async fetchUser({commit}) {
      try {
        const user = new User();
        const request = await user.fetch();
        commit('setCurrentUser', request.response.data.user);
      } catch(e) {
        commit('setCurrentUser', {});
      }
    },
    setCurrentUser({commit}, user) {
      commit('setCurrentUser', user);
    },    
    setToken({commit}, token) {
      commit('setToken', token);
    },
    setErrors({commit}, error) {
      commit('setErrors', error);
    },
    destroySession({commit}) {
      commit('setCurrentUser', {});
    },    
  },
  getters: {
    currentUser(state) {
      //return (Object.keys(state.currentUser).length === 0) ? undefined : state.currentUser
      return new User(state.currentUser);
    },
    getToken(state) {
      return state.token
    },
    getErrors(state) {
      return state.errors
    }
  }
}
